/**
 * Index Route - Portal Landing Page
 * Unified entry point with login/registration tabs
 */
import { createFileRoute } from "@tanstack/react-router";
import { PortalLandingPage } from "../pages/PortalLandingPage";

type SearchParams = {
  id?: string;
  code?: string;
  next?: string;
  tab?: string;
};

export const Route = createFileRoute("/")({
  component: PortalLandingPage,
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    return {
      id: typeof search.id === "string" ? search.id : undefined,
      code: typeof search.code === "string" ? search.code : undefined,
      next: typeof search.next === "string" ? search.next : undefined,
      tab: typeof search.tab === "string" ? search.tab : undefined,
    };
  },
});
